import { ROUTES_NAME } from "../../constants/routes"

export const menuData = [
    {
        name:'Home',
        route:ROUTES_NAME.HOME
    },
    {
        name:'About',
        route:ROUTES_NAME.ABOUT
    },
    {
        name:'Services',
        route:ROUTES_NAME.SERVICES
    },
    {
        name:'Contact Us',
        route:ROUTES_NAME.CONTACT_US
    },
]